import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddYearsOfExperience() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/YearsOfExperienceLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Years of Experience"
      alert="Years of Experience Added Successfully"
      addDataAPIEndpoint="/YearofExp/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Years of Experience",
              name: "YEL_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "YEL_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        YEL_Name: {
          required: true,
          
        },
        YEL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddYearsOfExperience;
